// extracted by mini-css-extract-plugin
module.exports = {"banner":"Speakers_banner__1uH_i","btn":"Speakers_btn__3xXvs","itemsOnImg":"Speakers_itemsOnImg__d1H7f"};